"use client";

import { useEffect, useRef } from "react";
import { useAppDispatch } from "@lib/redux/hooks";
import {
  initializeShortlist,
  ShortlistCar,
} from "@lib/redux/slices/shortlistSlice";

interface ShortlistInitializerProps {
  initialData: ShortlistCar[];
}

const ShortlistInitializer = ({ initialData }: ShortlistInitializerProps) => {
  const dispatch = useAppDispatch();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current) {
      dispatch(initializeShortlist(initialData));
      hasInitialized.current = true;
    }
  }, [dispatch, initialData]);

  return null;
};

export default ShortlistInitializer;
